<div class="reset-wrap">
    <div class="row mt-2 justify-content-center">
        <div class="col-4 reset-box">
            <div class="reset-form p-3">
                <form [formGroup]="resetForm!" (ngSubmit)="onSubmit()">
                    <div class="row reset-header mb-2 justify-content-center">
                        <div class="col-md-1 col-sm-12 p-0"></div>
                        <div class="col-md-10 col-sm-12 text-center">
                            <div class="float-left leaflet-logo-container" routerLink="">
                                <img src="/assets/img/header_logo.png" class="img-responsive logo leaflet-logo"
                                    alt="Leaflet" />
                            </div>
                        </div>
                        <div class="col-md-1 col-sm-12 p-0"></div>

                    </div>
                    <div class="row reset-sub-header">
                        <div class="col-md-1 col-sm-12 p-0"></div>
                        <div class="col-md-10 col-sm-12">
                            <h4 class="reset-text">Reset Password</h4>
                        </div>
                        <div class="col-md-1 col-sm-12 p-0"></div>
                    </div>
                    <div class="reset-body">
                        <div class="pwd-cnfrmPwd-wrap">
                            <div class="row">
                                <div class="col-md-1 col-sm-12 p-0"></div>



                                <div class="col-md-10 col-sm-12 p-0 ">
                                    <app-custom-input type="password" placeholder="Enter Password"
                                        fieldLabel="New Password" fieldId="newPassword"
                                        [fieldType]="resetFormGroupControls['newPassword']"
                                        formControlName="newPassword" [errorMessages]="errorMessages.newPassword"
                                        [submitted]="submitted" ngDefaultControl>
                                    </app-custom-input>
                                </div>



                                
                                <div class="col-md-1 col-sm-12 p-0"></div>

                            </div>

                            <div class="row">

                                <div class="col-md-1 col-sm-12 p-0"></div>
                                <div class="col-md-10 col-sm-12 p-0 ">

                                    <app-custom-input type="password" placeholder="Enter Confirm Password"
                                        fieldLabel="Confirm Password" fieldId="confirmPassword"
                                        [fieldType]="resetFormGroupControls['confirmPassword']"
                                        formControlName="confirmPassword"
                                        [errorMessages]="errorMessages.confirmPassword" [submitted]="submitted"
                                        ngDefaultControl>
                                    </app-custom-input>

                                    <!-- Show error if passwords do not match -->
                                    <div class="text-danger cnfm-matching" *ngIf="(submitted && resetForm.errors?.['passwordMismatch']) 
                                && !resetFormGroupControls['confirmPassword'].errors">
                                        New Password & Confirm Password must match.
                                    </div>
                                </div>

                                <div class="col-md-1 col-sm-12 p-0"></div>
                            </div>
                        </div>

                        <div class="row reset-btn">
                            <div class="col-md-1 col-sm-12 p-0"></div>
                            <div class="col-md-10 col-sm-12 btn-block p-0">
                                <button type="submit" class="btn">
                                    Submit
                                </button>
                            </div>
                            <div class="col-md-1 col-sm-12 p-0"></div>
                        </div>

                        <div class="row reset-wrap" style="padding:5px !important;">
                            <div class="col-md-1 col-sm-12"></div>
                            <div class="col-md-10 col-sm-12 reset-sub-wrap">
                                <span>Back to
                                    <a [routerLink]="['/login']" class="forgot-pass-link">Login
                                    </a>
                                </span>
                            </div>
                            <div class="col-md-1 col-sm-12 p-0"></div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>